var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("GetFormField")
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.customer.code")) + ":")
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Code))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.customer.Model_StatusReasonId")) +
                        ":"
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.StatusReason
                          ? _vm.rowData.StatusReason.Label
                          : ""
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.customer.status")) + ":")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.rowData.Status ? _vm.rowData.Status.Label : "")
                  )
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-tabs",
          [
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.customer.Customer"), active: "" }
              },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_Description1")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.Description1))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_CommercialTitle")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.CommercialTitle))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("insert.customer.Model_TaxOffice"))
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.TaxOffice))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("insert.customer.Model_TaxNumber"))
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.TaxNumber))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("insert.customer.Model_IsDutyFree"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("i", {
                            class:
                              _vm.rowData.IsDutyFree === 1
                                ? "fa fa-check text-success"
                                : "fa fa-times text-danger"
                          })
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_UseEInvoice")
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("i", {
                            class:
                              _vm.rowData.UseEInvoice === 1
                                ? "fa fa-check text-success"
                                : "fa fa-times text-danger"
                          })
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_IsTaxExemption")
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("i", {
                            class:
                              _vm.rowData.IsTaxExemption === 1
                                ? "fa fa-check text-success"
                                : "fa fa-times text-danger"
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("insert.customer.Model_CardTypeId"))
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.CardType
                                ? _vm.rowData.CardType.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("insert.customer.Model_TypeId"))
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.Type ? _vm.rowData.Type.Label : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_SalesTypeId")
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.SalesType
                                ? _vm.rowData.SalesType.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "insert.customer.Model_SalesDocumentTypeId"
                                )
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.SalesDocumentType
                                ? _vm.rowData.SalesDocumentType.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "insert.customer.Model_PriceListCategoryId"
                                )
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.PriceListCategory
                                ? _vm.rowData.PriceListCategory.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "insert.customer.Model_SalesPriceChangeRate"
                                )
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(_vm._s(_vm.rowData.SalesPriceChangeRate))
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_DeliveryDayParam")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.DeliveryDayParam))])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.CustomerLocations") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          [
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("list.location")))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.customer.Model_Code")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_Location_Description1"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.warehouse.Address")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_XPosition"
                                            )
                                          ) +
                                            " - " +
                                            _vm._s(
                                              _vm.$t(
                                                "insert.customer.Model_YPosition"
                                              )
                                            )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_ContactName"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_PhoneNumber1"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_FaxNumber"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_Alias"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_IsDefaultLocation"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_IsInvoiceAddress"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.Model_IsDeliveryAddress"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.isRouteNode1"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  [
                                    _vm._l(
                                      _vm.rowData.CustomerLocations,
                                      function(r, i) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c(
                                              "b-td",
                                              { staticClass: "text-center" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-map-marker-alt text-primary",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showMap(r)
                                                    }
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(r.Code))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(r.Description1))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(r.AddressDetail))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(r.XPosition) +
                                                  " - " +
                                                  _vm._s(r.YPosition)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(r.ContactName))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(r.PhoneNumber1))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(r.FaxNumber))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(r.Alias))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(
                                                  r.IsDefaultLocation == 1
                                                    ? _vm.$t("insert.yes")
                                                    : _vm.$t("insert.no")
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(
                                                  r.IsInvoiceAddress == 1
                                                    ? _vm.$t("insert.yes")
                                                    : _vm.$t("insert.no")
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(
                                                  r.IsDeliveryAddress == 1
                                                    ? _vm.$t("insert.yes")
                                                    : _vm.$t("insert.no")
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(
                                                  r.IsRouteNode == 1
                                                    ? _vm.$t("insert.yes")
                                                    : _vm.$t("insert.no")
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-modal",
                                      {
                                        ref: "LocationModal",
                                        attrs: {
                                          id: "location-modal",
                                          "hide-footer": "",
                                          "hide-header": ""
                                        }
                                      },
                                      [
                                        _c("NextLocation", {
                                          attrs: { Location: _vm.Location }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.CustomerClass") } },
              [
                _c(
                  "b-row",
                  { staticClass: "p-4" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_Category1Id")
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.Category1
                                ? _vm.rowData.Category1.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_Category2Id")
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.Category2
                                ? _vm.rowData.Category2.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_Category3Id")
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.Category3
                                ? _vm.rowData.Category3.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("insert.customer.Model_GroupId"))
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.Group ? _vm.rowData.Group.Label : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_DiscountGroup1Id")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.DiscountGroup1Id))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_DiscountGroup3Id")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.DiscountGroup3Id))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_DiscountGroup5Id")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.DiscountGroup5Id))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_DiscountGroup6Id")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.DiscountGroup6Id))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_DiscountGroup7Id")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.DiscountGroup7Id))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_DiscountGroup8Id")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.DiscountGroup8Id))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_SalesMethodId")
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.SalesMethod
                                ? _vm.rowData.SalesMethod.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_TradeFocusId")
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.TradeFocus
                                ? _vm.rowData.TradeFocus.Label
                                : ""
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "col-md-6 col-12 asc__showPage-card" },
                      [
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_DiscountGroup4Id")
                              )
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.DiscountGroup4Id))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_OwnerTypeId")
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.OwnerType
                                ? _vm.rowData.OwnerType.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("insert.customer.Model_ClassId"))
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.Class ? _vm.rowData.Class.Label : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("insert.customer.Model_ClassProposalId")
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.ClassProposal
                                ? _vm.rowData.ClassProposal.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "insert.customer.Model_ClassProposalReasonId"
                                )
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.ClassProposalReason
                                ? _vm.rowData.ClassProposalReason.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("insert.customer.Model_KindId"))
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.Kind ? _vm.rowData.Kind.Label : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "insert.customer.Model_GeographicEnvironmentId"
                                )
                              )
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.rowData.GeographicEnvironment
                                ? _vm.rowData.GeographicEnvironment.Label
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("insert.customer.Model_Field1"))
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.Field1))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("insert.customer.Model_Field2"))
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.Field2))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("insert.customer.Model_Field3"))
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.Field3))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("insert.customer.Model_Field4"))
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.Field4))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("insert.customer.Model_Field5"))
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.Field5))]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", { staticClass: "far fa-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("insert.customer.Model_TextField6"))
                          )
                        ]),
                        _c("p", [_vm._v(_vm._s(_vm.rowData.TextField6))])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.customer.CustomerFinancialInfo")
                }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(_vm._s(_vm.$t("insert.route.title")))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("insert.customer.Model_CreditLimit")
                                  )
                              )
                            ]),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.CreditLimit))]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("insert.customer.Model_RiskLimit")
                                  )
                              )
                            ]),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.RiskLimit))]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_IsDefaultLocation"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(_vm._s(_vm.rowData.IsDefaultLocation))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_CurrentCredit"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(_vm._s(_vm.rowData.CurrentCredit))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("insert.customer.Model_CurrentRisk")
                                  )
                              )
                            ]),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.CurrentRisk))]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_IsAutoBlockingOff"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(_vm._s(_vm.rowData.IsAutoBlockingOff))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("insert.customer.Model_IsBlocked")
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _c("i", {
                                class:
                                  _vm.rowData.IsBlocked === 1
                                    ? "fa fa-check text-success"
                                    : "fa fa-times text-danger"
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_BlockReasonId"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.rowData.BlockReason
                                    ? _vm.rowData.BlockReason.Label
                                    : ""
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_ManualInvoiceClosure"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(_vm._s(_vm.rowData.ManualInvoiceClosure))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_InvoiceCombineRuleId"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(_vm._s(_vm.rowData.InvoiceCombineRuleId))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("insert.customer.Model_FinanceCode")
                                  )
                              )
                            ]),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.FinanceCode))]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_CustomerRegion5Id"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.rowData.CustomerRegion5
                                    ? _vm.rowData.CustomerRegion5.Label
                                    : ""
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "8" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "insert.customer.CustomerCreditHistories"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-table", {
                              attrs: {
                                responsive: "",
                                items: _vm.rowData.CustomerCreditHistories,
                                fields: _vm.creditHistoriesFields
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(CreditDescription)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.value.Label) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(Currency)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.value.Label) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(CreditStartDate)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.dateConvertFromTimezone(
                                              data.value
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(CreditEndDate)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.dateConvertFromTimezone(
                                              data.value
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.customer.CustomerPaymentTypes") }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(_vm._s(_vm.$t("insert.route.title")))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_DefaultPaymentTypeId"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.rowData.DefaultPaymentType
                                    ? _vm.rowData.DefaultPaymentType.Label
                                    : ""
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _c("i", { staticClass: "far fa-circle" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "insert.customer.Model_PaymentPeriod"
                                    )
                                  )
                              )
                            ]),
                            _c("p", [_vm._v(_vm._s(_vm.rowData.PaymentPeriod))])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("insert.customer.Model_PaymentTypeId")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-table", {
                              attrs: {
                                responsive: "",
                                items: _vm.rowData.CustomerPaymentTypes,
                                fields: _vm.paymentTypeFields
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n                 "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(PaymentType)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.value.Label) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("insert.customer.Model_FixedTermId")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-table", {
                              attrs: {
                                responsive: "",
                                items: _vm.rowData.CustomFixedTerms,
                                fields: _vm.fixedTermFields
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: {
                  title: _vm.$t("insert.customer.CustomerItemDiscountCrts")
                }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "insert.customer.CustomerItemDiscountCrts"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-table", {
                              attrs: {
                                responsive: "",
                                items: _vm.rowData.CustomerItemDiscounts,
                                fields: _vm.discountFields
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.tag") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(_vm._s(_vm.$t("insert.customer.tag")))
                            ]),
                            _vm._v(" "),
                            _c("b-table", {
                              attrs: {
                                responsive: "",
                                items: _vm.rowData.CustomerLabels,
                                fields: _vm.customerLabelFields
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(Label)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.value.Label) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(LabelValue)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.value.Label) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              {
                attrs: { title: _vm.$t("insert.customer.customerTouchpoints") }
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "m-3 asc__showPage-card" },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("insert.customer.customerTouchpoints")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-table", {
                              attrs: {
                                responsive: "",
                                items: _vm.rowData.CustomerTouchpoints,
                                fields: _vm.customerTouchpointsFields
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "head()",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t(data.label)) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(TouchpointPriority)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.value.Label) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(TouchpointType)",
                                  fn: function(data) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.value.Label) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.preOrder") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          [
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.customer.orderCount")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("insert.customer.unit"))
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.customer.ItemCode")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.customer.ItemName")
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  _vm._l(
                                    _vm.rowData.CustomerPreOrders,
                                    function(r, i) {
                                      return _c(
                                        "b-tr",
                                        { key: i },
                                        [
                                          _c("b-td", [
                                            _vm._v(_vm._s(r.Quantity))
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(r.Unit ? r.Unit.Label : "")
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(r.Item ? r.Item.Code : "")
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(r.Item ? r.Item.Label : "")
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.asset") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          [
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.customer.assetName")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.customer.barcode")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.serialNumber"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "insert.customer.fixtureNumber"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  _vm._l(_vm.rowData.AssetLocations, function(
                                    r,
                                    i
                                  ) {
                                    return _c(
                                      "b-tr",
                                      { key: i },
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(r.Asset ? r.Asset.Label : "")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.SerialNumber))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.SerialNumber2))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.SerialNumber3))
                                        ])
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tab",
              { attrs: { title: _vm.$t("insert.customer.potentialAnalysis") } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "b-card",
                          [
                            _c(
                              "b-table-simple",
                              { attrs: { bordered: "", small: "" } },
                              [
                                _c(
                                  "b-thead",
                                  [
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.customer.question")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("b-th", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("insert.customer.answer")
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tbody",
                                  _vm._l(
                                    _vm.rowData.FieldSurveyResultDetails,
                                    function(r, i) {
                                      return _c(
                                        "b-tr",
                                        { key: i },
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                r.Question
                                                  ? r.Question.Label
                                                  : ""
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [_vm._v(_vm._s(r.Answer))])
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f01c0922", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f01c0922","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PotentialCustomer/get.vue
// module id = null
// module chunks = 